import React from "react";
import { FormHelperText } from "@mui/material";
import { CustomStyleFormHelperText } from "../../../../components/Styles";
import { CustomTextField } from "../../../../components/CustomTextField";
import CreateLayoutTabApp from "../Functionality/CreateLayoutTabApp";
import { LAYOUT_NAME_LENGTH } from "../Model/Model";
import LayoutThumbnail from "../SubComponents/LayoutThumbnail";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Create Layout tab: name of the layout and its structure.
 */
const CreateLayoutTab = ({ item, emptyFields, handleChange, onSelectType }) => {
    const { t, rows, typeRequired } = CreateLayoutTabApp({ item, emptyFields });

    return (
        <div className='d-flex flex-column gap-4'>
            <CustomTextField
                id='txt_clt_name'
                length={LAYOUT_NAME_LENGTH}
                name='name'
                value={item.name}
                trans='name'
                placeholder={t('enter_a_layout_name')}
                type='text'
                onChange={handleChange}
                emptyFields={emptyFields}
                required={true}
            />

            <p className='fs-14px ibl-font-w-700 text-uppercase text-center font-color-text-950'>
                {t('select_a_layout_from_the_list')}
            </p>

            <div>
                <div className={`d-flex flex-column gap-3 p-2 border-radius-8px ${typeRequired ? 'border-full-error-code-600' : ''}`}>
                    {rows.map((row, rowIndex) => (
                        <div key={rowIndex} className='d-flex gap-3'>
                            {row.map((type) => (
                                <div
                                    key={type.ID}
                                    id={`div_clt_layout_${type.ID}`}
                                    className={`event-monitoring-layout-option d-flex flex-column align-items-center gap-2 p-16px border-full-shades-100 border-radius-8px cursor-pointer ${item.typeId === type.ID ? 'event-monitoring-layout-option-selected background-primary-50' : 'background-shades-50'}`}
                                    onClick={() => onSelectType(type.ID)}
                                >
                                    <LayoutThumbnail type={type} />
                                    <p className='fs-14px ibl-font-w-600 font-color-general-950'>{t(type.TRANS)}</p>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                <FormHelperText error={true} sx={CustomStyleFormHelperText(false)}>
                    {typeRequired && t('requiredField')}
                </FormHelperText>
            </div>
        </div>
    );
};

export default CreateLayoutTab;
